const runtimeConfig = window.__APP_CONFIG__ || {};

export function getRuntimeConfig(key, fallback = "") {
    const value = runtimeConfig[key];
    return typeof value === "string" && value.trim() !== "" ? value : fallback;
}

export function getFirebaseConfig() {
    return {
        apiKey: getRuntimeConfig("FIREBASE_API_KEY"),
        authDomain: getRuntimeConfig("FIREBASE_AUTH_DOMAIN"),
        projectId: getRuntimeConfig("FIREBASE_PROJECT_ID"),
        storageBucket: getRuntimeConfig("FIREBASE_STORAGE_BUCKET"),
        messagingSenderId: getRuntimeConfig("FIREBASE_MESSAGING_SENDER_ID"),
        appId: getRuntimeConfig("FIREBASE_APP_ID"),
        measurementId: getRuntimeConfig("FIREBASE_MEASUREMENT_ID"),
    };
}
